import {
	calendarConstants
}from "./constants"
import {
	defAction
} from '../../../helpers/defaultAction'
import api from "./api"

export const exceptDaysActions = {
  getExcepdDays,
  clearExceptDays
}

function getExcepdDays(values){
	const dispatchObj = {
		constants : calendarConstants.getExceptDays,
		service   : {
			func   : api.getExceptDaysForReOrg,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearExceptDays(){
	return (dispatch) => dispatch({
		type: calendarConstants.getExceptDays.CLEAR
	})
}
